import {PlatformTable} from "../PlatformTable";
import withBreakpoint from "../../util/withBreakpoint";
import {withAppContext} from "../../util/withAppContext";

interface DashboardTable {
    state: any;
    props: any;
    applet: any;
}

// The dashboards in this realm, as a grid.
//
// PlatformTable, like every other list in this app. This was a hand-rolled column of bordered
// <Box>es over list.map() and Ed has now corrected the same thing four times (t6 Portal Users, the
// Tables landing page, the reference-list values editor, this). What the conversion buys is the
// same every time and none of it was ever going to be added by hand: column show/hide, resizing,
// the simple-search box, an honest footer count, and the 48px row conventions the rest of the suite
// uses -- so a dashboard list looks like a list rather than like this screen's own invention.
//
// THE NAME IS A LINK, not a row click. A dashboard's page is a routed, addressable URL and the
// standard is that such a thing is reachable by a real anchor -- see PlatformTable.renderLinkCell.
class DashboardTable extends PlatformTable {

    // The buffer during a refetch is the PREVIOUS one -- the guard every sibling table carries,
    // because a renderer reading the new buffer mid-fetch indexes past its end.
    row(params: any) {
        const buffer = this.state.fetchBackgroundOperation ? this.state.previousBuffer : this.state.buffer;
        if (!buffer || params.row.id > buffer.length - 1) return null;
        return buffer[params.row.id];
    };
}

export default withAppContext(withBreakpoint(DashboardTable));
